module.exports = __webpack_public_path__ + "static/media/3.dd012bdc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/3.svg
// module id = 140
// module chunks = 0